import { render, staticRenderFns } from "./ClinicAccreditations.vue?vue&type=template&id=196d9b17&"
import script from "./ClinicAccreditations.vue?vue&type=script&lang=js&"
export * from "./ClinicAccreditations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports